import type React from 'react'

import { MessageContainer } from '../ChatMessagesList/components/MessageContainer'
import css from './styles.module.css'

interface ActionsMessageProps {
  children: React.ReactNode
}

export const ActionsMessage: React.FC<ActionsMessageProps> = ({ children }) => (
  <MessageContainer className={css.message_actions}>
    {children}
  </MessageContainer>
)
